import * as yup from 'yup'
import { SYSTEM_MESSAGE_IDS } from '../../shared/constants/systemMessages.constants'

function generateValidationSchema(t: any) {
  const validationSchema = yup.object().shape({
    pageName: yup.string().required(t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
      Required_Field: `${t('HelpPage:form.label.pageName')}`,
    })),
    content: yup.string().required(t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
      Required_Field: `${t('HelpPage:form.label.content')}`,
    }))
  })

  return validationSchema
}

function generateValidationSchedulePublishingSchema(t: any) {
  const validationSchema = yup.object().shape({
    publishing: yup.number(),
    schedulePublishing: yup.date().nullable()
  })

  return validationSchema
}

export { generateValidationSchema, generateValidationSchedulePublishingSchema }
